const controls = {
  data() {
    return {
      // show popover based on string
      popoverId: '',
      popoverOptions: {
        animation: 'scale-fade',
        popoverReference: null,
        placement: this.blok.placement || 'bottom',
      },
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.popoverOptions.popoverReference = this.$refs.popoverReference
    })
  },
  methods: {
    closePopover() {
      this.popoverId = ''
    },
    openPopover(id) {
      // this.$emit('setId', this.blok._uid)
      this.popoverId = id
    },
  },
}

export { controls }
